module.exports = __webpack_public_path__ + "img/undisposed.d8f680ea.png";